import { useEffect, useState, useRef } from 'react'
import { useSnackbar } from 'notistack'
import { adminpanelservice } from '../services/Admin/adminPanelService'
import { useAdminAuth } from "../context/AdminAuthContext";

export const useAdminPanel = () => {
  const { enqueueSnackbar } = useSnackbar()
  const [isLoading, setIsLoading] = useState(false)
  const [studentsRecords, setStudentsRecords] = useState([])
  const { admin, isAuthenticated, authLoading } = useAdminAuth();
  
  const hasLoaded = useRef(false);
  const isMounted = useRef(true);

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  // Reset when not authenticated
  useEffect(() => {
    if (!isAuthenticated) {
      hasLoaded.current = false;
      setStudentsRecords([]);
    }
  }, [isAuthenticated]);

  useEffect(() => {
    // console.log("📋 useAdminPanel effect triggered", {
    //   isAuthenticated,
    //   authLoading,
    //   hasLoaded: hasLoaded.current
    // });

    if (!isAuthenticated || authLoading || hasLoaded.current) {
      return;
    }

    const loadStudents = async () => {
      if (!isMounted.current) return;
      
      try {
        setIsLoading(true);
        hasLoaded.current = true;
        // console.log("🔄 Loading students...");
        
        const students = await adminpanelservice.getstudentsRecords();
        
        if (isMounted.current) {
          // console.log("✅ Students loaded:", students.length);
          setStudentsRecords(students);
        }
      } catch (error) {
        console.error("❌ Error loading students:", error);
        if (isMounted.current) {
          enqueueSnackbar("Failed to load students", { variant: "error" });
          hasLoaded.current = false; // Allow retry
        }
      } finally {
        if (isMounted.current) {
          setIsLoading(false);
        }
      }
    };

    loadStudents();
  }, [isAuthenticated, authLoading, enqueueSnackbar]);

  return {
    isLoading: isLoading || authLoading,
    studentsRecords,
    adminProfile: admin,
    reloadStudents: () => {
      hasLoaded.current = false;
      // Force reload
      const load = async () => {
        try {
          setIsLoading(true);
          const students = await adminpanelservice.getstudentsRecords();
          setStudentsRecords(students);
        } catch (error) {
          enqueueSnackbar("Failed to reload students", { variant: "error" });
        } finally {
          setIsLoading(false);
        }
      };
      load();
    }
  }
}















// import { useCallback, useEffect, useState, useRef } from 'react'
// import { useSnackbar } from 'notistack'
// // after succesfully login and navigated to Admin Panel where students records need to check
// import { useNavigate } from 'react-router-dom'
// // call the AdminPanelservice 5.0
// import { adminpanelservice } from '../services/Admin/adminPanelService'
// import { useAdminAuth } from "../context/AdminAuthContext";

// export const useAdminPanel = () => {
//   // Authentic method is boolean - true false so shouldstore with plain var. - never call with object {useAuth}
//   // const useAuth = AdminAuthService.isAuthenticated()
  
//   const navigate = useNavigate()
//   const { enqueueSnackbar } = useSnackbar()
//   const [isLoading, setIsLoading] = useState(false)
//   const [adminProfile, setAdminProfile] = useState([])
//   const [studentsRecords, setStudentsRecords] = useState([])
//   const { admin, isAuthenticated, authLoading,checkAuth  } = useAdminAuth();

// // Track if we've already loaded students
//   const hasLoadedRef = useRef(false);
//   // Track current request ID to cancel stale requests
//   const requestIdRef = useRef(0);

//   // Clear loaded flag when auth changes
//   useEffect(() => {
//     if (!isAuthenticated) {
//       hasLoadedRef.current = false;
//     }
//   }, [isAuthenticated]);

//   // Load students only when authenticated
//   const loadStudents = useCallback(async () => {
//     if (!isAuthenticated || hasLoadedRef.current) return;
    
//     const currentRequestId = ++requestIdRef.current;
    
//     try {
//       setIsLoading(true);
//       const students = await adminpanelservice.getstudentsRecords();
      
//       // Only update if this is still the latest request
//       if (currentRequestId === requestIdRef.current) {
//         setStudentsRecords(students);
//         hasLoadedRef.current = true;
//       }
//     } catch (error) {
//       console.error("Failed to load students:", error);
//       if (currentRequestId === requestIdRef.current) {
//         enqueueSnackbar("Failed to load students", { variant: "error" });
//       }
//     } finally {
//       if (currentRequestId === requestIdRef.current) {
//         setIsLoading(false);
//       }
//     }
//   }, [isAuthenticated, enqueueSnackbar]);

//    // Load students on mount and when auth changes
//   useEffect(() => {
//     loadStudents();
//   }, [loadStudents]);



//   return {
    
//     isLoading: isLoading || authLoading,
//     studentsRecords,
//     adminProfile: admin,
//     reloadStudents: () => {
//       hasLoadedRef.current = false;
//       loadStudents();
//     }
//   }
// }
